//@mui
import { Stack } from '@mui/system';
import { Box, Typography } from '@mui/material';
//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
import { getAddBalanceState } from 'state/reducers/balance.reducers';
import { BalanceDepositType, balanceTransStepsPrefix, digitalBalanceAddStepsPrefix } from 'constants/balance.constants';
//components
import { FormHeader1, HeaderPage3 } from 'theme/elements/Headers';
//constants
import { useState } from 'react';
import BankAccountsDetails from '../../components/BankAccountsDetails';
import { BankAccount } from 'constants/bank-account.constants';
import { FormCard } from 'theme/elements/Forms';

export default function BankAccountDetailsForm(props: {
	handleBankListPick: any;
	accounts: BankAccount[];
	companyBankAccountId: any;
}) {
	const t = useAppSelector(selectTranslations);
	const balanceState = useAppSelector(getAddBalanceState);

	// Dynamic prefix based on state
	const translationPrefix = balanceState === BalanceDepositType.Digital ? digitalBalanceAddStepsPrefix : balanceTransStepsPrefix;

	const [selectedAccountId, setSelectedAccountId] = useState<number | null>(null);

	const handleBankPick = (val: number | null) => {
		if (props.accounts.find((bankAccount) => bankAccount.id === val)) {
			setSelectedAccountId(val);
			props.handleBankListPick(val);
		}
	};

	return (
		<Box component="form" noValidate>
			<FormCard>
				<Stack spacing={3}>
					<FormHeader1
						title={t(`${translationPrefix}.1.bank_account.title`)}
						text={t(`${translationPrefix}.1.bank_account.details`)}
					/>
					<Stack spacing={1}>
						<Typography variant="body3">
							{t(`${translationPrefix}.1.my_bank_account_list.title`)}
						</Typography>
						<BankAccountsDetails
							accounts={props.accounts}
							selectedAccountId={props.companyBankAccountId}
							handleBankPick={handleBankPick}
						/>
					</Stack>
				</Stack>
			</FormCard>
		</Box>
	);
}
